import { render } from "./configuration-link.vue?vue&type=template&id=1af8ccd8"
import script from "./configuration-link.vue?vue&type=script&lang=js"
export * from "./configuration-link.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__